import { Button, Form, Offcanvas } from "react-bootstrap";
import enums from "../../../utilities/enums";
import useApi from "../../../utilities/useApi";
import { useState } from "react";
import Loading from "../../common/loading";
import SimpleBar from "simplebar-react";
import SuccessModal from "../../common/successModal";
import SridSelector from "../../common/sridSelector";
import stringUtilities from "../../../utilities/stringUtilities";
import ConfigurationDialog from "../drawingTools/_configurationDialog";
import { defaultSrid } from "../../../utilities/sridData";

export default function DownloadData(props) {

    const { api } = useApi();
    const [isLoading, setIsLoading] = useState(false);
    const [srid, setSrid] = useState(defaultSrid);
    const [includePhotos, setIncludePhotos] = useState(false);
    const [success, setSuccess] = useState(null);
    const [showSridSelector, setShowSridSelector] = useState(false)
    const cancel = function () {
        if (props.onComplete) {
            props.onComplete();
        }
    }

    const download = function () {
        setIsLoading(true);
        let bounds = props.mapRef.current.getBounds();


        api.getData(props.organisationId, props.projectId, props.selectedJobs, props.selectedUsers, props.workflows, bounds.getNorth(), bounds.getSouth(), bounds.getWest(), bounds.getEast(), props.dateFrom, props.dateTo, 0, props.exportFormat, srid?.epsg === defaultSrid.epsg ? null : srid?.epsg, includePhotos, null, props.includeDeleted, null, () => {
            setIsLoading(false);
            setSuccess({ message: "Your export is being prepared. You will receive an email with a download link shortly." });
        }, (e) => {
            console.log(e);
            setIsLoading(false);
        });
    }

    return <>
        {success && <SuccessModal success={success} onDismiss={() => { setSuccess(null); cancel(); }} />}
        <Offcanvas show placement='end' scroll={false} backdrop={false} className={props.exportFormat > 1 && "download-with-projection"}>
            <Offcanvas.Header className='border-bottom'>
                <Offcanvas.Title>Download as {enums.ExportFormats[props.exportFormat]}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="d-flex flex-align-start flex-column h-100 w-100 ">
                    <div className="w-100 h-100 mb-auto overflow-y-auto">
                        {isLoading && <Loading />}
                        {!isLoading &&
                            <SimpleBar autoHide={false} className='simplebar-no-autohide' style={{ maxHeight: 'calc(100vh - 280px)', overflowX: 'hidden' }}>
                                {props.exportFormat > 1 && <>
                                    
                                    <Form.Group className='mb-3 w-100'>
                                        <Form.Label className='form-label fs-sm col-form-label'>
                                            Output Projection
                                        </Form.Label>

                                        <div className="d-flex justify-content-between align-items-center w-100">
                                            <p className="fs-xs m-0 text-truncate" style={{ minWidth: 0 }}>
                                                {srid.name} (EPSG: {srid.epsg})
                                            </p>

                                            <div className="ms-auto flex-shrink-0">
                                            <Button disabled={srid.epsg === defaultSrid.epsg} className="ms-5 me-2" size="xs" variant='secondary' onClick={() => setSrid(defaultSrid)}>Reset to default</Button>
                                            <Button size="xs" variant='secondary' onClick={() => setShowSridSelector(true)}>Select Projection</Button>
                                        </div>
                                        </div>
                                    </Form.Group>
                                    {
                                        props.exportFormat !== 5 && props.exportFormat !== 6 &&
                                        <>
                                            <Form.Group className='mb-3 row align-items-center'>
                                                <Form.Label className='form-label fs-sm col-form-label' htmlFor="download-include-photos">
                                                    Include Photos
                                                </Form.Label>
                                                <div className="d-flex align-items-center">
                                                    <Form.Check type='switch' id="download-include-photos" checked={includePhotos} onChange={(e) => setIncludePhotos(e.target.checked)} />
                                                </div>
                                            </Form.Group>
                                        </>
                                    }
                                </>}
                            </SimpleBar>
                        }
                    </div>
                    <div className="d-flex justify-content-between order-2 w-100">
                        <Button onClick={cancel} variant="secondary" size="sm">Cancel</Button>
                        <Button size="sm" variant="primary" onClick={download}><i className="fi-download me-2"></i> Download</Button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas id="srid-selector" show={showSridSelector} placement='end' scroll={ false } backdrop={ false } className="download-with-projection">
            <Offcanvas.Header className='border-bottom'>
                <Offcanvas.Title>Select Projection</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <div className="d-flex flex-column h-100 w-100">
                    <div className="w-100 flex-grow-1 overflow-hidden">
                        <SridSelector value={srid} onChange={sridObject => {
                            setSrid(sridObject)
                            setShowSridSelector(false)
                        }} />
                    </div>

                    <Button size="sm" variant='secondary' className="align-self-start" onClick={ () => setShowSridSelector(false) }>Close</Button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    </>
}